import { render, staticRenderFns } from "./FixedTitles.vue?vue&type=template&id=1b7b8a07&scoped=true&"
import script from "./FixedTitles.vue?vue&type=script&lang=js&"
export * from "./FixedTitles.vue?vue&type=script&lang=js&"
import style0 from "./FixedTitles.vue?vue&type=style&index=0&id=1b7b8a07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7b8a07",
  null
  
)

export default component.exports